import { defineStore } from 'pinia';
import { ModalDialogType } from './dialog-types';

export const useDialogStore = defineStore({
  id: 'dialog',

  state: () => ({
    isActive: false as boolean,
    title: null as string | null,
    message: null as string | null,
    type: null as ModalDialogType | null,
  }),

  getters: {
    // ...
  },

  actions: {
    setIsActive(state: boolean) {
      this.isActive = state;
    },
    setTitle(title: string | null) {
      this.title = title;
    },
    setMessage(message: string | null) {
      this.message = message;
    },
    setType(type: ModalDialogType | null) {
      this.type = type;
    },
  },
});
